
import AdminTrans from "../components/admin/AdminUserTransaction";

export default function AdminUserTransaction() {
  return (
    <div>
      <AdminTrans />
    </div>
  );
}
